jQuery.noConflict();
jQuery(document).ready(function($){
  "use strict";
  //Smart Resize Start
  $(window).smartresize(function(){
    if( $('.portfolio-container').length ){
      var $width = $('.portfolio-container').hasClass("no-space") ? 0 : 23;
      $('.portfolio-container').css({overflow:'hidden'}).isotope({itemSelector : '.item-row', masonry: { gutterWidth: $width } });
    }
  });//Smart Resize End

  //Window Load Start
  $(window).load(function(){
    if( $('.portfolio-container').length ){
      var $width = $('.portfolio-container').hasClass("no-space") ? 0 : 23;
      $('.portfolio-container').isotope({
        filter: '*',
        masonry: { gutterWidth: $width },
        animationOptions: { duration: 750, easing: 'linear', queue: false  }
      });
    }

    if($("div.sorting-container").length){
      $("div.sorting-container a").click(function(){
        $("div.sorting-container a").removeClass("active-all");
        var $width = $('.portfolio-container').hasClass("no-space") ? 0 : 23;
        var selector = $(this).attr('data-filter');
        $(this).addClass("active-all");

        $('.portfolio-container').isotope({
          filter: selector,
          masonry: { gutterWidth: $width },
          animationOptions: { duration: 750, easing: 'linear', queue: false  }
        });
        return false;
      });
    }

   
  });//Window Load End

});
